import React from 'react';
import { Shield } from 'lucide-react';
import Header from './components/Header11';
import Footer from './components/Footer11';

const PrivacyPolicy11 = () => {
    const sections = [
        { title: '1. Information We Collect', content: 'We collect information you provide directly to us, including your name, email address, postal address, phone number, and payment information when you make a purchase, create an account, or contact us. We also automatically collect certain information about your device, including IP address, browser type, operating system, and browsing behavior on our website.' },
        { title: '2. How We Use Your Information', content: 'We use your information to process orders, communicate with you about products and services, personalize your shopping experience, improve our website and services, send promotional offers (with your consent), and ensure security and fraud prevention.' },
        { title: '3. Information Sharing', content: 'We do not sell your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website, processing payments, and delivering orders. These partners are contractually obligated to keep your information confidential.' },
        { title: '4. Data Security', content: 'We implement industry-standard security measures to protect your personal information, including SSL encryption, secure payment processing, and regular security audits. However, no method of transmission over the internet is 100% secure.' },
        { title: '5. Cookies and Tracking', content: 'We use cookies and similar technologies to enhance your browsing experience, analyze site traffic, and personalize content. You can control cookie settings through your browser preferences.' },
        { title: '6. Your Rights', content: 'You have the right to access, update, or delete your personal information at any time. You can also opt out of marketing communications by clicking the unsubscribe link in our emails or contacting our support team.' },
        { title: '7. Data Retention', content: 'We retain your personal information for as long as necessary to fulfill the purposes outlined in this policy, unless a longer retention period is required by law. Order records are maintained for a minimum of 5 years for tax and legal purposes.' },
        { title: '8. Contact Us', content: 'If you have any questions about our privacy practices or wish to exercise your data rights, please contact us at privacy@veer.in or through our Contact page.' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Source+Sans+3:wght@300;400;600&display=swap');
            `}</style>

            <div style={{ fontFamily: "'Source Sans 3', -apple-system, sans-serif" }} className="min-h-screen bg-[#1C1917]">
                <Header />

                <main className="pt-[100px] pb-16 px-4 sm:px-6">
                    <div className="max-w-[800px] mx-auto">
                        <div className="text-center mb-12">
                            <div className="w-10 h-0.5 mx-auto mb-4" style={{ backgroundColor: '#D97706' }} />
                            <Shield size={32} style={{ color: '#D97706', margin: '0 auto 12px' }} />
                            <h1 className="text-3xl sm:text-4xl font-bold" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '2px' }}>
                                PRIVACY POLICY
                            </h1>
                            <p className="text-xs mt-3" style={{ color: '#A8A29E' }}>Last updated: March 2026</p>
                        </div>

                        <div className="space-y-8">
                            {sections.map((section, i) => (
                                <div key={i} className="p-6" style={{ backgroundColor: '#292524', borderLeft: '3px solid #D97706' }}>
                                    <h2 className="text-base font-semibold mb-3" style={{ fontFamily: "'Oswald', sans-serif", color: '#FAFAF9', textTransform: 'uppercase', letterSpacing: '1px' }}>
                                        {section.title}
                                    </h2>
                                    <p className="text-sm leading-relaxed" style={{ color: '#A8A29E' }}>{section.content}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </main>

                <Footer />
            </div>
        </>
    );
};

export default PrivacyPolicy11;
